import React from "react";
import { Link } from "react-router-dom";
import "./PublicDashboard.css";

export default function PublicDashboard() 
{
  const quickLinks = [
    { to: "/login", title: "Login", desc: "Access your dashboard and services." },
    { to: "/forgot-password", title: "Reset Password", desc: "Reset your password using registered mobile number." },
    { to: "/employee/new", title: "PU Employee Registration", desc: "Register as university employee." },
    { to: "/contact-us", title: "Contact Us", desc: "Reach support for help and queries." },
    { to: "/holidays", title: "Holiday List", desc: "View declared holidays and schedule." }
  ];

  return (
    <div className="pd-page">
      <section className="pd-hero">
        <div className="pd-wrap">
          <h1>
            PANJAB UNIVERSITY
          </h1>

        </div>
      </section>

      <div className="pd-wrap">
        <section className="pd-section">
          <h2>Quick Links</h2>
          <div className="pd-card-grid five-col">
            {quickLinks.map((item, index) => (
              <Link key={item.title} to={item.to} className="pd-card pd-step-card">
                <span className="pd-step-index">{index + 1}</span>
                <p className="pd-card-title">{item.title}</p>
                <p className="pd-card-desc">{item.desc}</p>
              </Link>
            ))}
          </div>
        </section>

        <section className="pd-section">
          <div className="pd-verified">
            <h2>Verified Employee Data and Controlled Access</h2>
            <p>
              Every action runs through authenticated access and module-based permissions,
              supporting secure, paperless, and transparent university governance.
            </p>
          </div>
        </section>

        <section className="pd-section">
          <h2>All Services</h2>
          <div className="dashboard-grid">
            <Icon to="/login" img="/icons/Login.png" label="Login" />
            <Icon to="/forgot-password" img="/icons/Reset.png" label="Reset Password" />
            <Icon to="/employee/new" img="/icons/Registration.png" label="PU Employee Registration" />
            <Icon to="/employee-instructions" img="/icons/Instructions.png" label="PU Employee Registration (Instructions)" />
            <Icon to="/college-teacher-registration" img="/icons/Registration.png" label="College Teacher Registration" />
            <Icon to="/guesthouse/info" img="/icons/GuestHouse.png" label="Guest House" />
            <IconPdf href="/tarrifdetails.pdf" img="/icons/GuestHouse.png" label="Guest House Tariff" />
            <Icon to="/holidays" img="/icons/Holiday.png" label="Holiday List" />
            <Icon to="/contact-us" img="/icons/ContactUs.png" label="Contact Us" />
            <Icon to="/student-instructions" img="/icons/Instructions.png" label="Student Registration (Instructions)" />
            <Icon to="/student-registration" img="/icons/Registration.png" label="Student Registration" />
          </div>
        </section>

        <div className="erp-intro">
          <p className="fw-bold text-center">S.A.R.V.A.T.R.A</p>
          <p className="text-center fw-semibold">
            Smart, Accountable, Resilient Value-Aligned Technology for Real-time Automation
          </p>
          <p className="text-justify">
            <strong>SARVATRA</strong> is an integrated, paperless Management Information System
            developed to streamline academic and administrative processes of Panjab University.
            It is empowered by modern digital governance to ensure transparency, efficiency,
            and secure information flow across departments, colleges, and stakeholders.
          </p>
          <p className="text-justify">
            SARVATRA enables seamless communication, real-time data access, and rule-based
            workflows, supporting a fearless, accountable, and future-ready university
            administration.
          </p>
          <p className="text-center fw-bold">"Empowering Transparent University Governance"</p>
        </div>
      </div>
    </div>
  );
}

/* REUSABLE ICON COMPONENT */
function Icon({ to, img, label }) {
  return (
    <Link to={to} className="icon-button">
      <img src={img} alt={label} />
      <p>{label}</p>
    </Link>
  );
}

function IconPdf({ href, img, label }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="icon-button">
      <img src={img} alt={label} />
      <p>{label}</p>
    </a>
  );
}